document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    requestSequence: 0,
    requestController: null,
    historyListener: null,
    mediaQuery: null,
    mediaListener: null,
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this._initLayout();
      this._setListeners();
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      this.historyListener = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        this._renderPage(searchParams, false);
      };
      window.addEventListener('popstate', this.historyListener);
      this.mediaQuery = window.matchMedia('(min-width: 768px)');
      this.mediaListener = () => this._initLayout();
      this.mediaQuery.addEventListener('change', this.mediaListener);
      this._initLayout();
    },
    _invalidateRequest() {
      this.requestSequence += 1;
      if (this.requestController) this.requestController.abort();
      this.requestController = null;
      return this.requestSequence;
    },
    destroy() {
      clearTimeout(this.t);
      this._invalidateRequest();
      if (this.historyListener) window.removeEventListener('popstate', this.historyListener);
      if (this.mediaQuery && this.mediaListener) this.mediaQuery.removeEventListener('change', this.mediaListener);
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);
      this._invalidateRequest();
      const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
      this.loading = true;
      this.t = setTimeout(() => {
        this._renderPage(searchParams);
        if (this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      const minLimit = Number(rangeInput[0].min),
        maxLimit = Number(rangeInput[1].max),
        priceGap = Math.min(1, Math.max(0, maxLimit - minLimit)),
        numberFormat = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

      rangeInput.forEach((input) => {
        input.addEventListener("input", (event) => {
          let minVal = Math.min(Math.max(Number(rangeInput[0].value), minLimit), maxLimit - priceGap),
            maxVal = Math.min(Math.max(Number(rangeInput[1].value), minLimit + priceGap), maxLimit);
          if (maxVal - minVal < priceGap) {
            if (event.target === rangeInput[0]) minVal = maxVal - priceGap;
            else maxVal = minVal + priceGap;
          }
          minVal = Number(minVal.toFixed(2));
          maxVal = Number(maxVal.toFixed(2));
          rangeInput[0].value = priceInput[0].value = minVal.toFixed(2);
          rangeInput[1].value = priceInput[1].value = maxVal.toFixed(2);
          range.style.setProperty('--left_range', (maxLimit ? minVal / maxLimit : 0) * 100 + '%');
          range.style.setProperty('--right_range', (maxLimit ? 100 - (maxVal / maxLimit) * 100 : 0) + '%');
          pricePreview[0].textContent = numberFormat.format(minVal);
          pricePreview[1].textContent = numberFormat.format(maxVal);
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");
      
      let minVal = Number(rangeInput[0].value).toFixed(2),
      maxVal = Number(rangeInput[1].value).toFixed(2);;
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },
    _updateURLHash(searchParams) {
      history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    },
    async _renderPage(searchParams, updateURLHash = true) {
      clearTimeout(this.t);
      const requestId = this._invalidateRequest();
      const controller = new AbortController();
      this.requestController = controller;
      this.searchParamsPrev = searchParams;
      this.loading = true;
      if (updateURLHash) this._updateURLHash(searchParams);
      const isCurrent = () => requestId === this.requestSequence && !controller.signal.aborted;
      try {
        let html = this.cachedResults[searchParams];
        if (!html) {
          const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&${searchParams}`;
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Filter request failed');
          html = await response.text();
        }
        if (!isCurrent()) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!parsed.getElementById('ProductGridContainer')) throw new Error('Filter content missing');
        this._renderResults(html);
        this.cachedResults[searchParams] = html;
      } catch (error) {
        if (isCurrent()) {
          delete this.cachedResults[searchParams];
          window.location.replace(`${window.location.pathname}${searchParams ? '?' + searchParams : ''}`);
        }
      } finally {
        if (requestId === this.requestSequence) {
          this.loading = false;
          this.requestController = null;
        }
      }
    },
    _renderResults(html) {
      this._renderFilters(html);
      this._renderProductGridContainer(html);
      this._renderProductCount(html);
      this.loading = false;
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const sortSelect = document.getElementById('FormSelectFilter');
      const updatedSortSelect = parsedHTML.getElementById('FormSelectFilter') ||
        parsedHTML.querySelector('template[x-teleport="#header-filter"]')?.content.querySelector('#FormSelectFilter');
      if (sortSelect && updatedSortSelect) sortSelect.value = updatedSortSelect.value;
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      document.querySelectorAll('[data-active-filter-tag]').forEach((activeTag) => {
        const updatedActiveTag = parsedHTML.getElementById(activeTag.id);
        if (updatedActiveTag) activeTag.innerHTML = updatedActiveTag.innerHTML;
      });
      if (selectBlockFiltesDrawer) {
        if (this.$el.id) {  
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesDrawer.innerHTML = parsedHTML.querySelector(blockFiltesDrawer).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside) {
        if (this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesAside.innerHTML = parsedHTML.querySelector(blockFiltesAside).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(html) {
      document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    },
    _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) container.innerHTML = count;
        if (containerDrawer) containerDrawer.innerHTML = count;
        if (container) container.classList.remove('loading');
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      if (container) container.innerHTML = html.getElementById('ProductPerPage').innerHTML;
    },
    _filterFocus() {
      if (!this.show) return;
      const closeButton = document.getElementById('CloseFilter');
      if (closeButton?.getClientRects().length) closeButton.focus();
    },
    _filterTrapFocus(event) {
      if (!this.show || event.key !== 'Tab') return;
      const panel = document.getElementById('ProductFilter');
      if (!panel) return;
      const elements = Array.from(panel.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]'))
        .filter(element => element.tabIndex >= 0 && !element.matches(':disabled') &&
          !element.closest('[inert]') && element.getClientRects().length &&
          getComputedStyle(element).visibility !== 'hidden');
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (!first) return;
      if (event.shiftKey && event.target === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && event.target === last) {
        event.preventDefault();
        first.focus();
      }
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});
